import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import { fetchAppConfig, getAppConfig } from 'domains/appContext/AppContext.store';
import { getIsSessionActive } from 'domains/delegation';
import { getUserCountry, getUserProfileSearchStatus, getUserRights, UserRole } from 'domains/user';
import { FOUND, getData, hasUserAnyRight } from 'utils';
import { Country } from 'utils/i18n/Country';

export const useFetchAppConfig = () => {
  const searchStatus = useSelector(getUserProfileSearchStatus);
  const appConfigStatus = useSelector(getAppConfig).searchStatus;
  const dispatch = useDispatch();
  useEffect(() => {
    if (!appConfigStatus && searchStatus === FOUND) {
      dispatch(fetchAppConfig());
    }
  }, [dispatch, searchStatus, appConfigStatus]);
};

export const getIsOilChunkUserR1 = (state: RootState): boolean => {
  const userCountry = getUserCountry(state);
  const userRoles = getData(getUserRights(state)) ?? [];
  const isDelegationActive = getIsSessionActive(state);
  return !isDelegationActive && userCountry === Country.FR.key && userRoles.includes(UserRole.R1);
};

export const getIsBulkOilUser = (state: RootState): boolean => {
  const userCountry = getUserCountry(state);
  const userRoles = getData(getUserRights(state)) ?? [];
  const allowedRoles = [UserRole.R1, UserRole.R2, UserRole.R3, UserRole.R3_MOTRIO];
  return userCountry === Country.FR.key && hasUserAnyRight(allowedRoles, userRoles);
};

export const useIsOilChunkUserR1 = () => useSelector(getIsOilChunkUserR1);

export const useIsBulkOilUser = () => useSelector(getIsBulkOilUser);
